module.exports = __webpack_public_path__ + "static/media/tweet.5b5926e8.svg";